"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const yup_1 = require("@hookform/resolvers/yup");
const react_1 = require("react");
const react_hook_form_1 = require("react-hook-form");
const react_router_dom_1 = require("react-router-dom");
const yup = __importStar(require("yup"));
const Utils_1 = require("../../../utils/Utils");
const auth_api_1 = require("../../../utils/api/auth/auth.api");
const react_hot_toast_1 = __importDefault(require("react-hot-toast"));
function UseResetPasswordForm() {
    const navigate = (0, react_router_dom_1.useNavigate)();
    const validationSchema = yup.object().shape({
        email: yup
            .string()
            .email()
            .required("L'email est champs requis")
            .label("email"),
        reset_password_code: yup
            .string()
            .required("Le code est un champs requis")
            .label("code"),
        password: (0, Utils_1.validatePassword)(yup),
        password_confirmation: yup
            .string()
            .required("Le mot de passe de confirmation est un champs requis")
            .oneOf([yup.ref("password")])
            .label("Password confirmation"),
    });
    const [resetPassword, { error, isSuccess, isLoading, data }] = (0, auth_api_1.useResetUserPasswordMutation)();
    const onSubmit = (data) => __awaiter(this, void 0, void 0, function* () {
        const res = yield resetPassword(data);
        console.log("reset password res", res);
    });
    const state = (0, react_router_dom_1.useLocation)().state;
    const { register, handleSubmit, formState: { errors }, clearErrors, setValue, setError, } = (0, react_hook_form_1.useForm)({
        resolver: (0, yup_1.yupResolver)(validationSchema),
    });
    const [password, setPassword] = (0, react_1.useState)("");
    const [haveMinUppercase, setHaveMinUppercase] = (0, react_1.useState)(false);
    const [haveMinLowercase, setHaveMinLowercase] = (0, react_1.useState)(false);
    const [haveMinNumber, setHaveMinNumber] = (0, react_1.useState)(false);
    const [haveMinCharacter, setHaveMinCharacter] = (0, react_1.useState)(false);
    const [haveMinSpecialCharacter, setHaveMinSpecialCharacter] = (0, react_1.useState)(false);
    const passwordHandleChange = (e) => {
        var password = e.target.value;
        setPassword(password);
        if ((0, Utils_1.countUppercase)(password)) {
            setHaveMinUppercase(true);
        }
        else {
            setHaveMinUppercase(false);
        }
        if ((0, Utils_1.countLowercase)(password)) {
            setHaveMinLowercase(true);
        }
        else {
            setHaveMinLowercase(false);
        }
        if ((0, Utils_1.countNumber)(password)) {
            setHaveMinNumber(true);
        }
        else {
            setHaveMinNumber(false);
        }
        if ((0, Utils_1.countCharacters)(password)) {
            setHaveMinCharacter(true);
        }
        else {
            setHaveMinCharacter(false);
        }
        if ((0, Utils_1.countSpecial)(password)) {
            setHaveMinSpecialCharacter(true);
        }
        else {
            setHaveMinSpecialCharacter(false);
        }
        setValue("password", e.target.value);
    };
    (0, react_1.useEffect)(() => {
        if (state === null || state === void 0 ? void 0 : state.email) {
            setValue("email", state.email);
        }
        else {
            setTimeout(() => navigate("/"), 1);
        }
    }, [state === null || state === void 0 ? void 0 : state.email]);
    (0, react_1.useEffect)(() => {
        var _a;
        if (error) {
            const err = error;
            const message = ((_a = err === null || err === void 0 ? void 0 : err.data) === null || _a === void 0 ? void 0 : _a.error) ||
                `Une erreur de statut ${err === null || err === void 0 ? void 0 : err.status} est survenue.`;
            setError("reset_password_code", { message: message });
        }
    }, [error]);
    (0, react_1.useEffect)(() => {
        if (isSuccess) {
            react_hot_toast_1.default.success("Votre mot de passe a été réinitialisé avec succés!", {
                duration: 5000,
                position: "top-center",
            });
            setTimeout(() => {
                navigate("/", {
                    replace: true,
                });
            }, 3000);
        }
    }, [isSuccess]);
    (0, react_1.useEffect)(() => {
        if (errors) {
            (0, Utils_1.cleannerError)(errors, clearErrors, 3000);
        }
    }, [errors]);
    return {
        register,
        errors,
        onSubmit: handleSubmit(onSubmit),
        clearErrors,
        isLoading,
        passwordHandleChange,
        haveMinCharacter,
        haveMinLowercase,
        haveMinNumber,
        haveMinSpecialCharacter,
        haveMinUppercase,
        password,
    };
}
exports.default = UseResetPasswordForm;
